// extracted by mini-css-extract-plugin
export default {"root":"mBJHfd","inner-container":"op8KCt","innerContainer":"op8KCt"};